// Port of api/fuel/app/classes/insights/hindex/peers.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'peers',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var sizeRows = Util.query(
            'SELECT track_hindex FROM hindex_track WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND track_hindex > 0 ORDER BY track_hindex ASC'
        )

        var sizes = []
        for (var i = 0; i < sizeRows.length; i++) {
            sizes.push(parseInt(sizeRows[i].track_hindex, 10))
        }

        var totalRows = Util.query(
            'SELECT COUNT(*) AS cnt FROM hindex_track WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND track_hindex > 0'
        )
        var totalUsers = totalRows.length ? parseInt(totalRows[0].cnt, 10) : 0

        var selfHindex = this._data.current.get_hindex()

        return {
            peers: {
                histogram: histogram(sizes, selfHindex),
                metrics: {
                    users: totalUsers,
                    percentile: Util.percentile(sizes, selfHindex),
                    median: selfHindex - Util.median(sizes)
                }
            }
        }

    }
})

function histogram(values, self) {
    var bucketCount = 50
    var position = 0

    var filteredValues = values.filter(function(x) { return x > 0 })
    var maxCollectionSize = Math.max.apply(null, values)
    var minCollectionSize = filteredValues.length ? Math.min.apply(null, filteredValues) : 1

    var logMinCollectionSize = Math.log10(minCollectionSize)
    var logMaxCollectionSize = Math.log10(maxCollectionSize)
    var bucketSize = (logMaxCollectionSize - logMinCollectionSize) / bucketCount

    var histogramData = []
    var labels = []
    var bucketRanges = []

    for (var i = 0; i < bucketCount; i++) {
        var bucketMin = Math.ceil(Math.pow(10, logMinCollectionSize + (bucketSize * i)))
        var bucketMax = Math.floor(Math.pow(10, logMinCollectionSize + (bucketSize * (i + 1))))

        if (bucketMax < bucketMin) bucketMax = bucketMin

        if (bucketRanges.length && bucketRanges[bucketRanges.length - 1][1] === bucketMin) {
            continue
        }

        bucketRanges.push([bucketMin, bucketMax])

        labels.push(
            bucketMin !== bucketMax
                ? 'h-index ' + bucketMin + '-' + bucketMax
                : 'h-index ' + bucketMin
        )

        histogramData.push(0)
    }

    for (var vi = 0; vi < values.length; vi++) {
        for (var bi = 0; bi < bucketRanges.length; bi++) {
            if (values[vi] >= bucketRanges[bi][0] && values[vi] <= bucketRanges[bi][1]) {
                histogramData[bi]++
                break
            }
        }
    }

    bucketCount = histogramData.length

    var minBucketSize = 50

    var newBucketRanges = []
    var newHistogram = []
    var newLabels = []
    var startBucketMin = 0
    var currentBucketCount = 0

    for (var hi = 0; hi < bucketCount; hi++) {
        if (!startBucketMin) startBucketMin = bucketRanges[hi][0]

        var bMin = bucketRanges[hi][0]
        var bMax = bucketRanges[hi][1]

        currentBucketCount += histogramData[hi]

        if (currentBucketCount >= minBucketSize || hi === bucketCount - 1) {
            var currentLabel = (startBucketMin !== bMax)
                ? 'h-index ' + startBucketMin + '-' + bMax
                : 'h-index ' + startBucketMin

            newBucketRanges.push([startBucketMin, bMax])
            newHistogram.push(currentBucketCount)
            newLabels.push(currentLabel)

            startBucketMin = 0
            currentBucketCount = 0
        }
    }

    for (var pi = 0; pi < newBucketRanges.length; pi++) {
        if (self >= newBucketRanges[pi][0] && self <= newBucketRanges[pi][1]) {
            position = pi
            break
        }
    }

    return {
        position: position,
        labels: newLabels,
        data: newHistogram
    }
}
